// extracted by mini-css-extract-plugin
export default {"GifContainer":"styles_GifContainer__9QpPE","gif":"styles_gif__y3Dh0","text":"styles_text__ZYtAe"};